import type { TRuleWithTheme } from '@/styles/theme';

export const formItem: TRuleWithTheme = () => ({
    '& .ant-form-item-label': {
        paddingLeft: 0,
    },
});
